import { handleActions } from 'redux-actions';
import {
  getAppointmentTypesRequest,
  getAppointmentTypesSuccess,
  getAppointmentTypesFailure,
} from './actions';

// `status` is the load-once gate for getAppointmentTypes():
//   idle    -> never requested (a call fetches)
//   loading -> request in flight (a call is a no-op)
//   loaded  -> list is authoritative for this store lifetime, EVEN IF EMPTY
//              (a call is a no-op)
//   error   -> last request failed; NOT retried automatically — only a fresh
//              call (a new mount) tries again
// Screens must never key a refetch on `appointmentTypes` itself: both the
// success and the failure branch replace it with a fresh array, so an effect
// like `if (!appointmentTypes.length) getAppointmentTypes()` with
// [appointmentTypes] deps refetched at network rate forever on an error,
// a timeout, or a legitimately empty result (2026-09-08 incident).
const initialState = {
  fetching: false,
  status: 'idle',
  appointmentTypes: [],
  error: null,
};

const appointmentTypesReducer = handleActions({
  [getAppointmentTypesRequest]: (state) => ({
    ...state,
    fetching: true,
    status: 'loading',
    error: null,
  }),
  [getAppointmentTypesSuccess]: (state, action) => ({
    ...state,
    fetching: false,
    status: 'loaded',
    appointmentTypes: action.payload || [],
  }),
  [getAppointmentTypesFailure]: (state, action) => ({
    ...state,
    fetching: false,
    status: 'error',
    appointmentTypes: [],
    error: action.payload,
  }),
}, initialState);

export default appointmentTypesReducer;
